import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentSelectedCategory = createSelector([selectAssortmentState], (state) => {
  return state.selectedCategory
})
